// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import MintUI from 'mint-ui'

Vue.config.productionTip = true

/*使用mint-ui框架*/
Vue.use(MintUI)
Vue.use(VueRouter)
Vue.use(VueResource)

document.addEventListener('DOMContentLoaded', function () {
  if (window.FastClick) window.FastClick.attach(document.body);
}, false);

/*路由*/
import routerUser from './routers/router'
let routerMap = [].concat(routerUser);

/*创建一个路由器实例
 并且配置路由规则*/
const router = new VueRouter({
  // mode: 'hash',
  // base: __dirname,
  routes: routerMap
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render(createElement){
    return createElement('app')
  },
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/pages/COECOACHInfo/main.js